import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppComponent } from '../../../app.component';
import { NavigationService, INavigationData, UserDetails, StorageService } from '../../service';
import { SubSink } from 'subsink';
import { CommonService } from '../../../../app/shared/service/common/common.service'
import { AppRoutes, DndPortalFeaturesConstants } from "../../../../app/shared/lib/api-constant";
import { UserControlService } from '../../service/userControl/user-control.service';
import { EFeatures } from '../../../shared/lib/model/common';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.scss'],
    standalone :false
})
export class AppMenuComponent implements OnInit, OnDestroy {

    hasCompany: boolean = false;
    listItems: Array<any>;

    LspUser: any = [];
    currentRoute: any = "";
    selectedRoute: any = {};
    nonRiskFeature: any = [];

    private subscription = new SubSink();
    getassignedsubfeatures: any;  
    ContractSubItems: { label: string; icon: string; featureKey: string; routerLink: any[] }[] = [];
    ListViewSubItems: { label: string; icon: string; featureKey: string; routerLink: any[];routerLinkActiveOptions?: { exact: boolean };  }[] = [];
    MasterDataManagementSubItems: { label: string; icon: string; featureKey: string; routerLink: any[] }[] = [];
    userhastplaccess: boolean;
    hasFeature: boolean;
    permissions: any;
    constructor(
        public storageService: StorageService,
        public app: AppComponent,
        private navigationService: NavigationService,
        private userControlService: UserControlService,
        private commonService: CommonService) {
       // this.populateMenus(this.permissions, commonService)
        this.userControlService.$userFeatures.subscribe((permission) => {
            this.permissions = permission.features.map((perm: any) => perm.featureKey);
            this.populateMenus(this.permissions, commonService);
        })
        this.subscription.add(
            this.navigationService.$currentNav.subscribe((selectedNav: INavigationData) => {
                if (selectedNav) {
                    this.currentRoute = selectedNav.route;
                }
            }),
        )



    }

    populateMenus(permissions: any, commonService: any) {
        this.checkListViewSubFeatures(permissions,commonService);
        this.checkContractSubFeatures(permissions, commonService);
        this.checkMasterDataManagementSubFeatures(permissions, commonService);
         const hasAlert = permissions?.includes?.(EFeatures.ALERT_SUBSCRIPTION);
        const allMenus: Array<any> = [];
        allMenus[0]= 
        {
            label: 'Home',
            icon: 'fal fa-home',
            featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.HOME,
            routerLink: [commonService.getRoute({ route: AppRoutes.User.HOME, type: 'User' })],
            command: (event: any) => { this.reRouteSameUrl(event); }
        } 
        // Extract features from permissions object
        // const featurePermissions = permissions.map((perm: any) => perm.feature);
        // console.log('Available permissions:', featurePermissions); // Add this
        // Define the full menu structure with feature constants
        permissions.forEach((perm: any) => {
    //     switch(perm){
    //     case EFeatures.ALERT_SUBSCRIPTION:
    //         allMenus.push(
    //         {
    //             label: 'Alert Subscription',
    //             icon: 'fa-solid fa-bell',
    //             featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.ALERT_SUBSCRIPTION,
    //             routerLink: [commonService.getRoute({ route: AppRoutes.User.ALERT_SUBSCRIPTION, type: 'User' })],
    //         }
    //     )
    //     break;
    // }
    })
 if(this.ListViewSubItems.length>0){
        allMenus.push(
        {
            label: 'List View',
            icon: 'fal fa-list',
            featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.LIST_VIEW,
            items:this.ListViewSubItems
        }
    )}
 if (hasAlert) {
    allMenus.push({
      label: 'Alert Subscription',
      icon: 'fa-solid fa-bell',
      featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.ALERT_SUBSCRIPTION,
      routerLink: [commonService.getRoute({ route: AppRoutes.User.ALERT_SUBSCRIPTION, type: 'User' })],
    });
  }
    if(this.ContractSubItems.length>0){
        allMenus.push(
        {
            label: 'Contract Agreement',
            icon: 'fal fa-home',
            featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.CONTRACT_AGREEMENT,
            items:this.ContractSubItems
        }
    )}
    if(this.MasterDataManagementSubItems.length>0){
        allMenus.push( {
            label: 'Master Data Management',
            icon: 'fa-regular fa-database',
            featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.MASTER_DATA_MANAGEMENT,
            items: this.MasterDataManagementSubItems
        }
    )}
    
    
    this.listItems = allMenus;
}


checkContractSubFeatures(permissions: any, commonService: any) {
    if (this.ContractSubItems.length>0) {
        this.ContractSubItems = []; 
    }
    permissions.forEach((perm: any) => {
    switch (perm) {
        case EFeatures.CONTRACT_AGREEMENT_CREATION:
            this.ContractSubItems.push({
                label: 'Contract Agreement Creation',
                icon: 'fal fa-home',
                featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.CONTRACT_AGREEMENT_CREATION,
                routerLink: [commonService.getRoute({ route: AppRoutes.User.CONTRACT_AGREEMENT_CREATION, type: 'User' })]
            });
            break;

        case EFeatures.CONTRACT_AGREEMENT_APPROVAL: 
            this.ContractSubItems.push({
                label: 'Contract Agreement Approval',
                icon: 'fal fa-home',
                featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.CONTRACT_AGREEMENT_APPROVAL,
                routerLink: [commonService.getRoute({ route: AppRoutes.User.CONTRACT_AGREEMENT_APPROVAL, type: 'User' })]
            });
            break;
    }
})}

checkListViewSubFeatures(permissions: any, commonService: any) {
    if (this.ListViewSubItems.length>0) {
        this.ListViewSubItems = []; 
    }
    permissions.forEach((perm: any) => {
    switch (perm) {
        case EFeatures.LIST_VIEW:
            this.ListViewSubItems.push({
                label: 'Active',
                icon: 'fal fa-list',
                featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.LIST_VIEW,
                routerLink: [commonService.getRoute({ route: AppRoutes.User.LIST_VIEW, type: 'User' })],
                 routerLinkActiveOptions: { exact: true }  
            });
             this.ListViewSubItems.push({
                label: 'Completed',
                icon:'fal fa-list',
                featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.LIST_VIEW_TERMINATED,
                 routerLink: [commonService.getRoute({ route: AppRoutes.User.LIST_VIEW_TERMINATED, type: 'User' })],
                  routerLinkActiveOptions: { exact: true }  
            });
             this.ListViewSubItems.push({
                label: 'Uncontracted',
                icon:'fal fa-list',
                featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.LIST_VIEW_UNMAPPED,
                 routerLink: [commonService.getRoute({ route: AppRoutes.User.LIST_VIEW_UNMAPPED, type: 'User' })],
                  routerLinkActiveOptions: { exact: true }  
            });
            break;

        case EFeatures.CONTRACT_AGREEMENT_APPROVAL: 
           
            break;
    }
})}
checkMasterDataManagementSubFeatures(permissions: any, commonService: any) {
    if (this.MasterDataManagementSubItems.length>0) {   
        this.MasterDataManagementSubItems = [];
    }
    permissions.forEach((perm: any) => {
    switch (perm) {
        case EFeatures.ROLE_MANAGEMENT:
            this.MasterDataManagementSubItems.push({    
                label: 'Role Management',
                icon: 'fa-regular fa-tower-control',
                featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.ROLE_MANAGEMENT,
                routerLink: [commonService.getRoute({ route: AppRoutes.User.ROLE_MANAGEMENT, type: 'User' })]
            });
            break;
            case EFeatures.USER_MANAGEMENT:
                this.MasterDataManagementSubItems.push({
                    label: 'User Management',
                    icon: 'fa-regular fa-users',
                    featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.USER_MANAGEMENT,
                    routerLink: [commonService.getRoute({ route: AppRoutes.User.USER_MANAGEMENT, type: 'User' })]
                });
                break;
            case EFeatures.PORT_MASTER:
                this.MasterDataManagementSubItems.push({
                    label: 'Port Master',
                    icon: 'fa-solid fa-anchor',
                    featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.PORT_MASTER,
                    routerLink: [commonService.getRoute({ route: AppRoutes.User.PORT_MASTER_DATA_MANAGEMENT, type: 'User' })]
                });
                break;
            case EFeatures.COMPANY_MASTER:
                this.MasterDataManagementSubItems.push({
                    label: 'Company Master',
                    icon: 'fa-regular fa-building',
                    featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.COMPANY_MASTER,
                    routerLink: [commonService.getRoute({ route: AppRoutes.User.COMPANY_MANAGEMENT, type: 'User' })]
                });
                break;
            case EFeatures.CURRENCY_MANAGEMENT:
                this.MasterDataManagementSubItems.push({
                    label: 'Currency Management',
                    icon: 'fa-solid fa-chart-mixed-up-circle-currency',
                    featureKey: DndPortalFeaturesConstants.DndMenuFeaturesConstants.CURRENCY_MANAGEMENT,
                    routerLink: [commonService.getRoute({ route: AppRoutes.User.CURRENCY_MANAGEMNT, type: 'User' })]
                });
                break;
    }
})}


    reRouteSameUrl(ev: any) {
        // this.commonService.updateSameRouteNavigation(false);
    }

    ngOnInit() {
        //this.populateMenus(this.permissions, this.commonService)
    }

    checkFeatures() {

    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
